<template>
  <div class="flex flex-row justify-between">
    <div v-if="showPageSize">
      <BaseSelect label="name" :options="sizeOptions" v-model="pageSize" />
    </div>
    <div v-if="buttons.length">
      <BaseButton
        class="mr-3 text-sm btn"
        size="none"
        variant="blue-transparent"
        v-for="(btn, index) in buttons"
        :key="`pagination-${index}-btn`"
        :disabled="btn.disabled"
        @click="onPaginate(btn.page)"
      >
        <span :class="{'font-bold': btn.page === curPage}">
          {{ btn.page }}
        </span>
      </BaseButton>
    </div>
    <div v-if="buttons.length">
      <BaseButton
        class="mr-3 btn"
        size="none"
        variant="blue-transparent"
        :disabled="!hasPrevPage"
        @click="onPrevPage"
      >
        <BaseIcon name="arrow-left2" width="13" height="19" />
      </BaseButton>
      <BaseButton
        class="btn"
        size="none"
        variant="blue-transparent"
        :disabled="!hasNextPage"
        @click="onNextPage"
      >
        <BaseIcon name="arrow-right2" width="13" height="19" />
      </BaseButton>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '@/components/global/base-icon';
  import BaseButton from '@/components/global/base-button';
  import BaseSelect from '@/components/global/base-select';

  export default {
    name: 'BasePagination',

    components: {
      BaseIcon,
      BaseButton,
      BaseSelect,
    },

    props: {
      showPageSize: {
        type: Boolean,
        default: false,
      },
      pagination: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        sizeOptions: [
          {
            size: 10,
            name: 'По 10',
          },
          {
            size: 20,
            name: 'По 20',
          },
          {
            size: 30,
            name: 'По 30',
          },
        ],
        pageSize: null,
      };
    },

    computed: {
      curPage() {
        return this.pagination.current_page ?? 0;
      },

      lastPage() {
        return this.pagination.last_page ?? 0;
      },

      isFirstPage() {
        return this.curPage === 1;
      },

      isLastPage() {
        return this.curPage === this.lastPage;
      },

      hasNextPage() {
        return this.curPage < this.lastPage;
      },

      hasPrevPage() {
        return this.curPage > 1;
      },

      buttons() {
        if (this.curPage === 0 || this.lastPage === 1) {
          return [];
        }

        let visibleCnt = 2;
        let reservedEndCnt = 1;
        let reservedStartCnt = 2;

        let deltaEnd = 0;
        let startRange = this.curPage - (visibleCnt + reservedStartCnt);

        if (startRange < 1) {
          deltaEnd = Math.abs(startRange) + 1;
          startRange = 2;
        } else {
          startRange = startRange + reservedStartCnt;
        }

        let deltaStart = 0;
        let endRange = this.curPage + (visibleCnt + reservedEndCnt) + deltaEnd;

        if (endRange >= this.lastPage) {
          deltaStart = endRange - this.lastPage + reservedEndCnt;
          endRange = this.lastPage - 1;
        }

        startRange = startRange - deltaStart;
        if (startRange <= 1) {
          startRange = 2;
        }

        let result = [this.makeButton(1, this.isFirstPage)];

        if (startRange - 1 > 1) {
          result.push(this.makeButton('...', true));
        }

        if (startRange <= endRange) {
          for (let i = startRange; i <= endRange; i++) {
            result.push(this.makeButton(i, false));
          }
        }

        if (endRange + 1 < this.lastPage) {
          result.push(this.makeButton('...', true));
        }

        result.push(this.makeButton(this.lastPage, this.isLastPage));
        return result;
      },
    },

    methods: {
      makeButton(page, disabled) {
        return {page: page, disabled: disabled};
      },
      onNextPage() {
        this.$emit('paginate', this.curPage + 1);
      },
      onPrevPage() {
        this.$emit('paginate', this.curPage - 1);
      },
      onPaginate(page) {
        if (this.curPage !== page) {
          this.$emit('paginate', page);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn {
    width: rem(36px);
    height: rem(36px);

    svg {
      color: #0050B2;
    }

    &:disabled {
      svg {
        color: #A7A8AB;
      }
    }
  }
</style>
